import React from 'react'

import styled from 'styled-components'

import { APP_DEFAULT_STATE, GlobalModalTypeEnum, MODALS_DEFAULT_STATE, ModalsPlugin } from '@api/local'
import { Spacer, Paragraph, Button } from '@client/components'
import { Modal, ModalFormContainer } from '@client/components/molecules'
import { ModalActionContainer } from '@client/components/Theme'
import { useConfig } from '@contexts/ConfigProvider'
import { useGetAppQuery, useGetModalsQuery, useUserCartQuery } from '@hooks/api'
import { DeviceTypeEnum } from '@uctypes/api/globalTypes'

const ActionContainer = styled.div`
  ${ModalActionContainer()}
`
export interface GetCookingModalProps {
  title?: string
  message?: string
  primaryActionText?: string
  secondaryActionText?: string
  maxWidth?: string
  minWidth?: string
  headerContainerPadding?: string
}

export function GetCookingModal({
  title,
  message,
  primaryActionText,
  secondaryActionText = 'Cancel',
  maxWidth,
  minWidth,
  headerContainerPadding,
}: GetCookingModalProps): JSX.Element {

  const { data: appData = { app: { ...APP_DEFAULT_STATE } } } = useGetAppQuery()
  const { data: modalsData = { modals: { ...MODALS_DEFAULT_STATE } } } = useGetModalsQuery()
  const config = useConfig()
  const { data: userCartData } = useUserCartQuery({ ssr: config.fetchSSRQuery() })
  const checkoutStatus = userCartData?.currentUser?.checkoutStatus
  const isMobile = appData.app.deviceType === DeviceTypeEnum.MOBILE

  const titleValue = title || 'Let\'s get cooking!'
  const messageValue = message || 'Sign up to add Meal Kits to your cart.'
  const primaryActionTextValue = primaryActionText || 'Let\'s go!'
  const secondaryActionTextValue = secondaryActionText || 'Skip for now'
  const maxWidthValue = maxWidth || (isMobile ? '100%' : '500px')
  const minWidthValue = minWidth || (isMobile ? undefined : '500px')
  // const headerContainerPaddingValue = headerContainerPadding || (isMobile ? undefined : '0 46px 0 56px')

  const _handleClose = () => {
    ModalsPlugin.shared().toggleGlobalModal(false, GlobalModalTypeEnum.GET_COOKING)
  }

  const _handlePrimaryActionClicked = () => {
    _handleClose()
    if (typeof window !== 'undefined') {
      window.location.href = '/meal-kit/plans'
      window.sessionStorage.removeItem('checkoutFlowType')
    }
  }

  const _handleSecondaryActionClicked = () => {
    _handleClose()
  }

  return (
    <Modal
      open={modalsData?.modals?.getCooking}
      fullscreen={false}
      title={titleValue}
      maxWidth={maxWidthValue}
      minWidth={minWidthValue}
      showCloseButton
      onClose={_handleClose}>
      <ModalFormContainer className='form-container'>
        <Paragraph variant='p1' align='center'>{messageValue}</Paragraph>
        <Spacer universal='32px' />
        <ActionContainer>
          <Button color='black' fullWidth title={primaryActionTextValue} onClick={_handlePrimaryActionClicked} />
          <Spacer universal='16px' />
          {/* <Link variant='l2' decoration='underline' onClick={_handleSecondaryActionClicked}> {secondaryActionTextValue} </Link> */}
          <Button color='black' variant='secondary' fullWidth title={secondaryActionTextValue} onClick={_handleSecondaryActionClicked} />
        </ActionContainer>
      </ModalFormContainer>
    </Modal>
  )
}
